export const NATTER_EXPLAINER_VIDEO = 'https://app.natter.co/attachments/Open_Natter_Promo.mp4';
